import { updateLeasedEquipmentStatus } from "actions/Utilities/LeasedEquipmentStatus";
import { toast } from "components/toastNotification";
import React from "react";
import { useMutation } from "react-query";
import { ILeasedEquipStatus } from "../Types";

export default function useUpdateLeasedEquipmentStatus() {
  const { mutate } = useMutation(
    (Data: ILeasedEquipStatus) => updateLeasedEquipmentStatus(Data),
    {
      onSuccess: (res) => {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "Status Updated Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Status Updated Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Updating Status failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "The data already exists!":
            toast.fire(
              "Updating Status failed ",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
          case res.includes("Action object"):
            toast.fire("Updating Status failed ", `Error: ${res}`, "error");
            break;
          default:
            toast.fire("Updating Status failed", `${res.Message}`, "error");
        }
      },
      onError: (error: any) => {
        toast.fire("Update Status failed", `Error: ${error}`, "error");
      },
    }
  );
  return mutate;
}
